var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6617_47267)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5893 6.27444C14.9135 4.95022 14.9135 2.80569 13.5893 1.48147C12.4174 0.309594 10.5705 0.15725 9.22285 1.12053L9.18535 1.14631C8.84785 1.38772 8.77051 1.85647 9.01191 2.19163C9.25332 2.52678 9.72207 2.60647 10.0572 2.36506L10.0947 2.33928C10.8471 1.80256 11.876 1.88694 12.5275 2.54084C13.2658 3.27913 13.2658 4.47444 12.5275 5.21272L9.89785 7.84709C9.15957 8.58538 7.96426 8.58538 7.22598 7.84709C6.57207 7.19319 6.4877 6.16428 7.02441 5.41428L7.05019 5.37678C7.2916 5.03928 7.21191 4.57053 6.87676 4.33147C6.5416 4.09241 6.07051 4.16975 5.83145 4.50491L5.80566 4.54241C4.84004 5.88772 4.99238 7.73459 6.16426 8.90647C7.48848 10.2307 9.63301 10.2307 10.9572 8.90647L13.5893 6.27444ZM1.41113 5.726C0.0869141 7.05022 0.0869141 9.19475 1.41113 10.519C2.58301 11.6908 4.42988 11.8432 5.77754 10.8799L5.81504 10.8541C6.15254 10.6127 6.22988 10.144 5.98848 9.80881C5.74707 9.47366 5.27832 9.39397 4.94316 9.63538L4.90566 9.66116C4.15332 10.1979 3.12441 10.1135 2.47285 9.45959C1.73457 8.71897 1.73457 7.52366 2.47285 6.78538L5.10254 4.15334C5.84082 3.41506 7.03613 3.41506 7.77441 4.15334C8.42832 4.80725 8.51269 5.83616 7.97598 6.5885L7.9502 6.626C7.70879 6.9635 7.78848 7.43225 8.12363 7.67131C8.45879 7.91038 8.92988 7.83303 9.16895 7.49788L9.19473 7.46038C10.1604 6.11272 10.008 4.26584 8.83613 3.09397C7.51191 1.76975 5.36738 1.76975 4.04316 3.09397L1.41113 5.726Z",
    fill: "#F14242"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6617_47267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.3bc1b3d6a336522166d749dacdd77bf2.svg";
export { ForwardRef as ReactComponent };